<div class="purchases">
  <!-- Normal mode with tabs -->
  <ng-container *ngIf="!isViewAllPurchases && !isViewAllSubscriptions">
    <ul
      ngbNav
      #nav="ngbNav"
      (navChange)="onTabChange($event)"
      [(activeId)]="active"
      class="nav-tabs"
    >
      <li [ngbNavItem]="1">
        <button [ngClass]="{ 'active-tab': isActive(1) }" ngbNavLink>All transactions</button>
        <ng-template ngbNavContent>
          <ng-container *ngIf="limitedOneTimePurchases?.length; else noSubscriptions">
            <div class="flex flex-column mt-3 gap-3">
              <stxt-one-time-purchase-card
                *ngFor="let purchase of limitedOneTimePurchases"
                [purchase]="purchase"
                (click)="openTransactionInfo(purchase)"
                (keydown.enter)="openTransactionInfo(purchase)"
                tabindex="-1"
              ></stxt-one-time-purchase-card>
            </div>
            <div *ngIf="shouldShowViewAllButton" class="mt-3">
              <stxt-button
                [buttonConfig]="viewAllBtnConfig"
                (click)="openAllPurchases()"
                (keydown.enter)="openAllPurchases()"
                tabindex="0"
                class="w-full"
              >
                {{ viewAllBtnConfig.text }}
              </stxt-button>
            </div>
          </ng-container>
        </ng-template>
      </li>
      <li [ngbNavItem]="2">
        <button [ngClass]="{ 'active-tab': isActive(2) }" ngbNavLink>Subscriptions</button>
        <ng-template ngbNavContent>
          <ng-container *ngIf="limitedSubscriptions?.length; else noSubscriptions">
            <div class="flex flex-column gap-1">
              <stxt-purchases-subscription-card
                *ngFor="let subscription of limitedSubscriptions"
                [subscriptionItem]="subscription"
                (click)="openSubscriptionManagementEvent.emit(subscription)"
                (keydown.enter)="openSubscriptionManagementEvent.emit(subscription)"
                (openPayment)="openSubscriptionCheckout.emit($event)"
                tabindex="-1"
              ></stxt-purchases-subscription-card>
            </div>
            <div *ngIf="shouldShowViewAllSubscriptionsButton" class="mt-3">
              <stxt-button
                [buttonConfig]="viewAllBtnConfig"
                (click)="openAllSubscriptions()"
                (keydown.enter)="openAllSubscriptions()"
                tabindex="0"
                class="w-full"
              >
                {{ viewAllBtnConfig.text }}
              </stxt-button>
            </div>
          </ng-container>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
  </ng-container>

  <!-- View all mode (no tabs, just the list) -->
  <div *ngIf="isViewAllPurchases">
    <ng-container *ngIf="oneTimePurchase?.length; else noSubscriptions">
      <div class="flex flex-column mt-3 gap-3">
        <stxt-one-time-purchase-card
          *ngFor="let purchase of oneTimePurchase"
          [purchase]="purchase"
          (click)="openTransactionInfo(purchase)"
          (keydown.enter)="openTransactionInfo(purchase)"
          tabindex="-1"
        ></stxt-one-time-purchase-card>
      </div>
    </ng-container>
  </div>

  <div *ngIf="isViewAllSubscriptions">
    <ng-container *ngIf="subscriptionsList?.length; else noSubscriptions">
      <div class="flex flex-column mt-3 gap-1">
        <stxt-purchases-subscription-card
          *ngFor="let subscription of subscriptionsList"
          [subscriptionItem]="subscription"
          (click)="openSubscriptionManagementEvent.emit(subscription)"
          (keydown.enter)="openSubscriptionManagementEvent.emit(subscription)"
          (openPayment)="openSubscriptionCheckout.emit($event)"
          tabindex="-1"
        ></stxt-purchases-subscription-card>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #noSubscriptions>
  <div class="no-subscription">
    <h4 class="no-subscription_heading">No purchases yet</h4>
    <p class="no-subscription_subheading">
      Your purchase history is empty, but it doesn't have to be.
    </p>
    <img
      src="/assets/d2c-images/no_subscription.png"
      class="no-subscription_img"
      alt="no-subscription"
    />
    <stxt-button
      class="no-subscription_discover"
      [buttonConfig]="discoverBtnConfig"
      (click)="closeProfileEvent.emit()"
      (keydown.enter)="closeProfileEvent.emit()"
      tabindex="0"
    >
      {{ discoverBtnConfig.text }}
    </stxt-button>
  </div>
</ng-template>
